module.exports = "label#securityLabel {\n  display: block; }\n\n.custom-checkbox {\n  margin-top: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/liquidaciones-modal/liquidaciones-modal.component.scss
// module id = ./src/app/components/partials/liquidaciones-modal/liquidaciones-modal.component.scss
// module chunks = main